import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";
import React from "react";

export const KeyIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue73c'}</MuiIcon>
    );
}
